import Vue from 'vue'
import axios from 'axios';
import {
  reToken,
} from "@/services/login";
import {jsonConfig} from "./config";
import {Loading, Message, MessageBox} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {handleTips} from "./tool";

let refreshToken = 0 // 换token只请求一次标识
let TokenInvalidFlag = 0;//token 失效只提示一次
let resIng = false;

//1、创建axios 实例
const service = axios.create(jsonConfig);

// todo 添加一个请求拦截器，用于设置请求过渡状态
service.interceptors.request.use((config) => {
  //注册获取验证码不需要cookie
  config.headers['Authorization'] = Vue.$cookies.get('token');
  let reg = config.url.indexOf('/admin/login/register') !== -1 ||
    config.url.indexOf('/admin/app/app') !== -1 ||
    config.url.indexOf('/admin/user/password') !== -1;
  if (!reg && !Vue.$cookies.get('token') && TokenInvalidFlag == 0) {
    Message.warning('登录信息失效，请重新登录!')
    setTimeout(() => {
      window.location.replace('/');
      Vue.ls.clear()
    }, 500);
    TokenInvalidFlag = 1;
  }
  if (Vue.$cookies.get('token') && Vue.$cookies.get('tokenTime') - (+new Date()) < 10 * 60 * 1000 && refreshToken !== 1 && !resIng) {
    refreshToken = 1;
    reToken({
      access_token: Vue.$cookies.get('access_token'),
      refresh_token: Vue.$cookies.get('re_token'),
      grant_type: 'refresh_token'
    }).then((res) => {
      if (res.code === 0) {
        refreshToken = 0;
        //设置cookie 30分钟失效
        let time = +new Date() + res.data.expires_in * 1000;//半个小时后的时间戳
        Vue.$cookies.set('tokenTime', time);
        Vue.$cookies.set('token', 'Bearer' + ' ' + res.data.access_token, `${res.data.expires_in / 60}min`);
        Vue.$cookies.set('re_token', res.data.refresh_token, `${res.data.expires_in / 60}min`);
        Vue.$cookies.set('access_token', res.data.access_token, `${res.data.expires_in / 60}min`);
      }
    })
  }
  // 请求开始，蓝色过渡滚动条开始出现
  NProgress.start();
  resIng = true;
  return config;
}, (error) => {
  return Promise.reject(error);
});

// todo 添加一个返回拦截器
service.interceptors.response.use((response) => {
  if (response.data.code != 0) {
    Message.warning(response.data.msg);
  }
  // 请求结束，蓝色过渡滚动条消失
  NProgress.done();
  resIng = false;
  return response;
}, (error) => {
  // 请求结束，蓝色过渡滚动条消失
  // 即使出现异常，也要调用关闭方法，否则一直处于加载状态很奇怪
  NProgress.done();
  return Promise.reject(error);
});

/**
 * 核心函数，可通过它处理一切请求数据，并做横向扩展
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {options} 请求配置，针对当前本次请求；
 * @param loading 是否显示loading
 * @param mock 本次是否请求mock而非线上
 * @param error 本次是否显示错误
 */
function request(url, params, options = {loading: true, mock: false, error: true}) {
  let loadingInstance;
  // 请求前loading
  if (params.loading) loadingInstance = Loading.service();
  return new Promise((resolve, reject) => {
    let data = {}
    // get请求使用params字段
    if (params.method == 'get') data = {params: params.data};
    // post请求使用data字段
    if (params.method == 'post') data = {data: params.data};
    if (params.method == 'put') data = {data: params.data};
    if (params.method == 'delete') data = {data: params.data};

    //todo 处理操作前确认框提示语
    const tips = handleTips(url, params.method);

    if (tips) {
      MessageBox.confirm(tips, '温馨提示', {type: 'warning'}).then(() => {
        service({url, method: params.method, ...data}).then((res) => {
          if (res.status === 200) {
            const {data, code, msg} = res.data;
            if (code == 0 && (!data || data == "成功" || data == true) && params.promptMessage) {
              Message.success(params.promptMessage);
            }
            resolve(res.data);
          }
        }).catch((error) => {
          //todo 处理错误(可以获取到error.response和error.message)
          if (error && error.response && error.response.data) {
            Message.error(error.response.data.msg);
          }
        }).finally(() => {
          loadingInstance.close();
        })
      }).catch(() => loadingInstance.close())
    } else {
      service({url, method: params.method, ...data}).then((res) => {
        if (res.status === 200) {
          const {data, code, msg} = res.data;
          if (code == 0 && (!data || data == "成功" || data == true) && params.promptMessage) {
            Message.success(params.promptMessage);
          }
          resolve(res.data);
        }
      }).catch((error) => {
        //todo 处理错误(可以获取到error.response和error.message)
        if (error.response && error.response.status == 424 && TokenInvalidFlag == 0) {
          //token失效
          Message.warning('登录已失效，请重新登录！');
          setTimeout(() => {
            window.location.replace('/');
            Vue.ls.clear()
          }, 500);
          TokenInvalidFlag = 1;
        } else if (error.response && error.response.status == 426) {
          //用户名密码错误
          if (error && error.response && error.response.data) {
            Message.error(error.response.data.msg);
          }
        } else if (error.response && error.response.status != 424 && error.response && error.response.status != 426) {
          if (error && error.response && error.response.data) {
            Message.error(error.response.data.msg);
          }
        }
      }).finally((err) => {
        loadingInstance.close();
      })
    }

  })
}

export default request;





// WEBPACK FOOTER //
// ./src/utils/request-axios.js